import React from 'react';
import { RefreshCwIcon } from 'lucide-react';
interface FilterBarProps {
  sliceBy: string;
  timeframe: string;
  topN: number;
  viewMode: 'aggregated' | 'individual';
  onSliceByChange: (value: string) => void;
  onTimeframeChange: (value: string) => void;
  onTopNChange: (value: number) => void;
  onViewModeChange: (value: 'aggregated' | 'individual') => void;
  onRefresh: () => void;
}
export function FilterBar({
  sliceBy,
  timeframe,
  topN,
  viewMode,
  onSliceByChange,
  onTimeframeChange,
  onTopNChange,
  onViewModeChange,
  onRefresh
}: FilterBarProps) {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6" data-id="element-1">
      <div className="flex flex-wrap items-end gap-4" data-id="element-2">
        <div className="flex-1 min-w-[180px]" data-id="element-3">
          <label htmlFor="slice-by" className="block text-xs font-semibold text-gray-700 uppercase tracking-wide mb-2" data-id="element-4">
            Slice By
          </label>
          <select id="slice-by" value={sliceBy} onChange={e => onSliceByChange(e.target.value)} className="w-full px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 font-medium focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all hover:border-gray-400" data-id="element-5">
            <option value="lead-source" data-id="element-6">Lead Source</option>
            <option value="loan-officer" data-id="element-7">Loan Officer</option>
            <option value="loan-manager" data-id="element-8">Loan Manager</option>
            <option value="property-state" data-id="element-9">Property State</option>
          </select>
        </div>

        <div className="flex-1 min-w-[180px]" data-id="element-10">
          <label htmlFor="timeframe" className="block text-xs font-semibold text-gray-700 uppercase tracking-wide mb-2" data-id="element-11">
            Timeframe
          </label>
          <select id="timeframe" value={timeframe} onChange={e => onTimeframeChange(e.target.value)} className="w-full px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 font-medium focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all hover:border-gray-400" data-id="element-12">
            <option value="today" data-id="element-13">Today</option>
            <option value="yesterday" data-id="element-14">Yesterday</option>
            <option value="last-7-days" data-id="element-15">Last 7 Days</option>
            <option value="last-30-days" data-id="element-16">Last 30 Days</option>
            <option value="this-month" data-id="element-17">This Month</option>
            <option value="last-month" data-id="element-18">Last Month</option>
            <option value="this-quarter" data-id="element-19">This Quarter</option>
            <option value="this-year" data-id="element-20">This Year</option>
          </select>
        </div>

        <div className="flex-1 min-w-[140px]" data-id="element-21">
          <label htmlFor="top-n" className="block text-xs font-semibold text-gray-700 uppercase tracking-wide mb-2" data-id="element-22">
            Top N
          </label>
          <input id="top-n" type="number" min="1" max="100" value={topN} onChange={e => onTopNChange(parseInt(e.target.value) || 10)} className="w-full px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-sm text-gray-900 font-medium focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all hover:border-gray-400" data-id="element-23" />
        </div>

        <div className="hidden sm:block w-px h-10 bg-gray-300 self-center" data-id="element-24"></div>

        <div className="flex-1 min-w-[200px]" data-id="element-25">
          <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wide mb-2" data-id="element-26">
            Team View
          </label>
          <div className="inline-flex w-full rounded-lg border border-gray-300 bg-gray-50 p-1" role="group" data-id="element-27">
            <button type="button" onClick={() => onViewModeChange('aggregated')} className={`flex-1 px-4 py-2 text-sm font-semibold rounded-md transition-all ${viewMode === 'aggregated' ? 'bg-white text-blue-700 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} aria-pressed={viewMode === 'aggregated'} data-id="element-28">
              Aggregated
            </button>
            <button type="button" onClick={() => onViewModeChange('individual')} className={`flex-1 px-4 py-2 text-sm font-semibold rounded-md transition-all ${viewMode === 'individual' ? 'bg-white text-blue-700 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} aria-pressed={viewMode === 'individual'} data-id="element-29">
              Individual
            </button>
          </div>
        </div>

        <button onClick={onRefresh} className="px-6 py-2.5 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700 active:bg-blue-800 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all flex items-center gap-2 shadow-sm hover:shadow" aria-label="Refresh data" data-id="element-30">
          <RefreshCwIcon className="h-4 w-4" aria-hidden="true" data-id="element-31" />
          Refresh
        </button>
      </div>
    </div>;
}